import { createSlice } from "@reduxjs/toolkit";

export const IdleTime = createSlice({
  name: "idle",
  initialState: {
    idleTime: new Date(),
  },
  reducers: {
    IdleAction: (state, action) => {
      state.idleTime = action.payload;
    },
  },
});

export const { IdleAction } = IdleTime.actions;

export default IdleTime.reducer;
